import { useEffect } from "react";

/**
 * Hook to take action when key is pressed.
 */
const useKeyDown = ({
	onKeyDown,
	disableIfAnyInputHasFocus,
}: { onKeyDown?: (event: KeyboardEvent) => void; disableIfAnyInputHasFocus?: boolean } = {}) => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			const activeEl = document.activeElement?.tagName || "";
			if (disableIfAnyInputHasFocus && ["input", "textarea"].includes(activeEl.toLowerCase())) {
				return;
			}

			onKeyDown && onKeyDown(event);
		};
		window.addEventListener("keydown", handleKeyDown);

		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [onKeyDown, disableIfAnyInputHasFocus]);
};

export default useKeyDown;
